import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const state = {

}


export default new Vuex.Store({
    state,
    modules: {
        user
    },
    
    // 严格模式，开发环境使用
    strict: process.env.NODE_ENV !== 'production'
})


// WEBPACK FOOTER //
// ./src/store/index.js